import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T, useTranslate } from 'shared/helper/translate';
import LanguageToggle from 'shared/components/LanguageToggle';
import Link from 'shared/components/Link';
import { getApiBaseUrl } from 'shared/helper/request';
import ColumnOfLinks from './ColumnOfLinks';
var MobileNav = function MobileNav(_ref) {
  var chinaLocalization = _ref.chinaLocalization,
    displayedDropdown = _ref.displayedDropdown,
    headerLinks = _ref.headerLinks,
    path = _ref.path,
    siteLanguage = _ref.siteLanguage,
    siteLanguages = _ref.siteLanguages,
    toggleDropdown = _ref.toggleDropdown,
    translationContext = _ref.translationContext,
    updateSiteLanguage = _ref.updateSiteLanguage,
    user = _ref.user,
    userName = _ref.userName,
    setShowMobileMenu = _ref.setShowMobileMenu,
    showCurie = _ref.showCurie,
    useGroupedNavigation = _ref.useGroupedNavigation;
  var account = headerLinks.account,
    accountAJE = headerLinks.accountAJE,
    accountCurie = headerLinks.accountCurie,
    accountGrouped = headerLinks.accountGrouped,
    additionalServices = headerLinks.additionalServices,
    curieServices = headerLinks.curieServices,
    formattingServices = headerLinks.formattingServices,
    fundingServices = headerLinks.fundingServices,
    preCurieLaunchAutomatedTools = headerLinks.preCurieLaunchAutomatedTools,
    automatedTools = headerLinks.automatedTools,
    learnLinks = headerLinks.learnLinks,
    companyLinks = headerLinks.companyLinks;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var loggedInLinks = useGroupedNavigation ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ColumnOfLinks, {
    title: accountAJE.title,
    links: accountAJE.links,
    setShowMobileMenu: setShowMobileMenu,
    siteLanguage: siteLanguage
  }), showCurie ? /*#__PURE__*/React.createElement(ColumnOfLinks, {
    title: accountCurie.title,
    links: accountCurie.links,
    setShowMobileMenu: setShowMobileMenu,
    siteLanguage: siteLanguage
  }) : null, /*#__PURE__*/React.createElement(ColumnOfLinks, {
    title: accountGrouped.title,
    links: accountGrouped.links,
    setShowMobileMenu: setShowMobileMenu,
    siteLanguage: siteLanguage
  })) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "user-name"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Hello %s",
    params: userName.length > 12 ? '' : userName
  }), "!"), /*#__PURE__*/React.createElement(ColumnOfLinks, {
    links: account.links,
    setShowMobileMenu: setShowMobileMenu,
    siteLanguage: siteLanguage
  }));
  return /*#__PURE__*/React.createElement("div", {
    id: "mobile-nav"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "column-of-links-list"
  }, !chinaLocalization ? /*#__PURE__*/React.createElement("li", {
    className: "nav-item dropdown mb-3 ".concat(displayedDropdown === 'languageToggle' ? 'show' : ''),
    role: "menuitem"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": t(siteLanguage),
    type: "button",
    className: "nav-link dropdown-toggle w-100",
    href: "#",
    onClick: function onClick() {
      return toggleDropdown('languageToggle');
    },
    "aria-expanded": "false"
  }, /*#__PURE__*/React.createElement(T, {
    source: "".concat(siteLanguage)
  }), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-caret-down"
  })), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-menu ".concat(displayedDropdown === 'languageToggle' ? 'show' : ''),
    role: "menu"
  }, siteLanguages.map(function (language) {
    return /*#__PURE__*/React.createElement("div", {
      key: language.code,
      className: "dropdown-item"
    }, /*#__PURE__*/React.createElement(LanguageToggle, {
      path: path,
      updateSiteLanguage: updateSiteLanguage,
      language: language.code,
      translationContext: translationContext
    }, language.name));
  }))) : null, /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, useGroupedNavigation ? null : /*#__PURE__*/React.createElement("h3", {
    className: "column-of-links-title"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Account"
  })), user.loggedIn ? loggedInLinks : /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Log In or Register'),
    type: "button",
    className: "nav-button",
    "data-track": "click",
    "data-track-action": "button click",
    "data-track-label": "login or register",
    onClick: function onClick() {
      return setShowMobileMenu(false);
    }
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/".concat(siteLanguage, "/login"),
    className: "log-in nav-link"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Log In or Register"
  })))), useGroupedNavigation ? /*#__PURE__*/React.createElement("hr", {
    className: "mobile-hr"
  }) : null, /*#__PURE__*/React.createElement(ColumnOfLinks, {
    title: additionalServices.title,
    links: additionalServices.links,
    setShowMobileMenu: setShowMobileMenu,
    siteLanguage: siteLanguage
  }), useGroupedNavigation ? null : /*#__PURE__*/React.createElement("hr", {
    className: "mobile-hr"
  }), /*#__PURE__*/React.createElement(ColumnOfLinks, {
    title: formattingServices.title,
    links: formattingServices.links,
    setShowMobileMenu: setShowMobileMenu,
    siteLanguage: siteLanguage
  }), useGroupedNavigation ? null : /*#__PURE__*/React.createElement("hr", {
    className: "mobile-hr"
  }), /*#__PURE__*/React.createElement(ColumnOfLinks, {
    title: fundingServices.title,
    links: fundingServices.links,
    setShowMobileMenu: setShowMobileMenu,
    siteLanguage: siteLanguage
  }), useGroupedNavigation ? null : /*#__PURE__*/React.createElement("hr", {
    className: "mobile-hr"
  }), showCurie ? /*#__PURE__*/React.createElement(ColumnOfLinks, {
    title: automatedTools.title,
    links: automatedTools.links,
    setShowMobileMenu: setShowMobileMenu,
    siteLanguage: siteLanguage
  }) : /*#__PURE__*/React.createElement(ColumnOfLinks, {
    title: preCurieLaunchAutomatedTools.title,
    links: preCurieLaunchAutomatedTools.links,
    setShowMobileMenu: setShowMobileMenu,
    siteLanguage: siteLanguage
  }), /*#__PURE__*/React.createElement("hr", {
    className: "mobile-hr"
  }), showCurie ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ColumnOfLinks, {
    title: curieServices.title,
    links: curieServices.links,
    setShowMobileMenu: setShowMobileMenu,
    siteLanguage: siteLanguage
  }), /*#__PURE__*/React.createElement("hr", {
    className: "mobile-hr"
  })) : null, /*#__PURE__*/React.createElement(ColumnOfLinks, {
    title: learnLinks.title,
    links: learnLinks.links,
    setShowMobileMenu: setShowMobileMenu,
    siteLanguage: siteLanguage
  }), useGroupedNavigation ? null : /*#__PURE__*/React.createElement("hr", {
    className: "mobile-hr"
  }), /*#__PURE__*/React.createElement(ColumnOfLinks, {
    title: companyLinks.title,
    links: companyLinks.links,
    setShowMobileMenu: setShowMobileMenu,
    siteLanguage: siteLanguage
  }), /*#__PURE__*/React.createElement("hr", {
    className: "mobile-hr"
  }), /*#__PURE__*/React.createElement("li", {
    className: "d-flex justify-content-between"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-label": t('Pricing'),
    className: "nav-button mobile-nav-button"
  }, /*#__PURE__*/React.createElement("a", {
    "aria-label": t('Pricing'),
    href: "https://aje.com/pricing",
    className: "mobile-nav-link"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.pricing"
  }))), /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Get a Quote'),
    type: "button",
    className: "nav-button mobile-nav-button",
    "data-track": "click",
    "data-track-action": "button click",
    "data-track-label": "get a price quote",
    onClick: function onClick() {
      return setShowMobileMenu(false);
    }
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/prices/quote/new",
    className: "mobile-nav-link"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Get a Quote"
  })))), /*#__PURE__*/React.createElement("li", {
    className: "mt-3 w-100"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Order Now'),
    type: "button",
    className: "nav-button mobile-nav-button w-100",
    "data-track": "click",
    "data-track-action": "button click",
    "data-track-label": "order-now",
    onClick: function onClick() {
      return setShowMobileMenu(false);
    }
  }, /*#__PURE__*/React.createElement("a", {
    "aria-label": t('Order Now'),
    href: "".concat(getApiBaseUrl(), "/researcher/submit/new"),
    className: "nav-link"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Order Now"
  }))))));
};
export default MobileNav;